{
  "PROFILE_SETTINGS": {
    "LINK": "Setări profil",
    "TITLE": "Setări profil",
    "BTN_TEXT": "Actualizeaza profil",
    "DELETE_AVATAR": "Șterge avatarul",
    "AVATAR_DELETE_SUCCESS": "Avatar a fost șters cu succes",
    "AVATAR_DELETE_FAILED": "Există o eroare în timp ce ștergeți avatarul, vă rugăm să încercați din nou",
    "UPDATE_SUCCESS": "Profilul dvs. a fost actualizat cu succes",
    "PASSWORD_UPDATE_SUCCESS": "Parola ta a fost schimbată cu succes",
    "AFTER_EMAIL_CHANGED": "Profilul tău a fost actualizat cu succes, te rugăm să te autentifici din nou pentru că datele tale de autentificare au fost modificate",
    "FORM": {
      "PICTURE": "Profile Picture",
      "AVATAR": "Imagine de profil",
      "ERROR": "Vă rugăm să remediați erorile din formular",
      "REMOVE_IMAGE": "Elimină",
      "UPLOAD_IMAGE": "Încarcă imaginea",
      "UPDATE_IMAGE": "Actualizare imagine",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Adresa ta de email este identitatea ta și este folosită pentru a te autentifica."
      },
      "SEND_MESSAGE": {
        "TITLE": "Taste rapide pentru a trimite mesaje",
        "NOTE": "Puteți selecta o tastă rapidă (enter sau Cmd/Ctrl+Enter) în funcție de preferințele dumneavoastră de a scrie.",
        "UPDATE_SUCCESS": "Setările au fost actualizate cu succes",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Introduceți (↵)",
            "CONTENT": "Trimiteți mesaje apăsând tasta Enter în loc să faceți clic pe butonul trimitere."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Trimiteți mesaje apăsând tasta Cmd/ Ctrl + enter în loc să faceți clic pe butonul trimitere."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Implicit",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Semnătura mesajului personal",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Salvarea semnăturii mesajului",
        "API_ERROR": "Nu s-a putut trimite! Încearcă din nou",
        "API_SUCCESS": "Semnătura salvată cu succes",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Dimensiunea imaginii trebuie să fie mai mică de {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Semnătura mesajului",
        "ERROR": "Semnătura mesajului nu poate fi goală",
        "PLACEHOLDER": "Introduceți semnătura mesajului personal aici."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parola",
        "NOTE": "Actualizarea parolei ar reseta autentificările pe mai multe dispozitive.",
        "BTN_TEXT": "Schimba parola"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token acces",
        "NOTE": "Acest token poate fi utilizat dacă construiți o integrare bazată pe API",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "Copiază",
        "RESET": "Reset",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Unable to regenerate access token. Please try again"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Nimic",
          "MINE": "Assigned",
          "ALL": "Toate",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Nimic",
          "ASSIGNED": "Conversații atribuite",
          "ALL_CONVERSATIONS": "Toate conversațiile"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tonul de alertă:"
        },
        "CONDITIONS": {
          "TITLE": "Condiții de alertă:",
          "CONDITION_ONE": "Trimiteți alerte audio numai dacă fereastra browserului nu este activă",
          "CONDITION_TWO": "Trimiteți alerte la fiecare 30 de ani până când toate conversațiile atribuite sunt citite"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Citeşte mai mult"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificări prin e-mail",
        "NOTE": "Actualizați preferințele de notificare prin e-mail aici",
        "CONVERSATION_ASSIGNMENT": "Trimite notificări prin e-mail atunci când o conversație îmi este atribuită",
        "CONVERSATION_CREATION": "Trimite notificări prin e-mail atunci când o conversație nouă este creată",
        "CONVERSATION_MENTION": "Trimiterea notificărilor prin e-mail atunci când sunteți menționat într-o conversație",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor prin e-mail atunci când se creează un mesaj nou într-o conversație atribuită",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor prin e-mail atunci când se creează un mesaj nou într-o conversație atribuită",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-mail",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them"
      },
      "API": {
        "UPDATE_SUCCESS": "Preferințele de notificare sunt actualizate cu succes",
        "UPDATE_ERROR": "A apărut o eroare la actualizarea preferințelor, încercați din nou"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificări push",
        "NOTE": "Actualizați preferințele de notificare push aici",
        "CONVERSATION_ASSIGNMENT": "Trimite notificări push atunci când o conversație îmi este atribuită",
        "CONVERSATION_CREATION": "Trimite notificări push atunci când o conversație nouă este creată",
        "CONVERSATION_MENTION": "Trimiterea notificărilor push atunci când sunteți menționat într-o conversație",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor push atunci când se creează un mesaj nou într-o conversație atribuită",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Trimiterea notificărilor push atunci când se creează un mesaj nou într-o conversație participantă",
        "HAS_ENABLED_PUSH": "Ați activat apăsarea pentru acest browser.",
        "REQUEST_PUSH": "Activează notificările push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagine de profil"
      },
      "NAME": {
        "LABEL": "Numele tău complet",
        "ERROR": "Te rugăm să introduci un nume valid",
        "PLACEHOLDER": "Te rugăm să introduci un nume valid"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nume afişat",
        "ERROR": "Te rugăm să introduci un nume valid",
        "PLACEHOLDER": "Te rugăm să introduci numele tău, care va fi folosit în conversații"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilitate",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Ocupat",
          "OFFLINE": "Deconectat"
        },
        "SET_AVAILABILITY_SUCCESS": "Avatar a fost șters cu succes",
        "SET_AVAILABILITY_ERROR": "Nu s-a putut seta disponibilitatea, vă rugăm să încercați din nou",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "Adresa ta de email",
        "ERROR": "Vă rugăm să introduceți o adresă de e-mail validă",
        "PLACEHOLDER": "Te rugăm să introduci adresa ta de e-mail, aceasta va fi afișată în conversații"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Parola curentă",
        "ERROR": "Vă rugăm să introduceţi un nume de agent",
        "PLACEHOLDER": "Vă rugăm să introduceți parola curentă"
      },
      "PASSWORD": {
        "LABEL": "Parolă nouă",
        "ERROR": "Te rugăm să introduci o parolă pentru lungimea de 6 caractere sau mai mult",
        "PLACEHOLDER": "Te rog introdu o noua parola"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmare parolă nouă",
        "ERROR": "Confirmarea parolei trebuie să se potrivească cu parola",
        "PLACEHOLDER": "Vă rugăm să reintroduceți noua parolă"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Schimba",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "SELECTOR_SUBTITLE": "Selectaţi un cont din următoarea listă",
    "PROFILE_SETTINGS": "Profile settings",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "CHANGELOG": "Changelog",
    "LOGOUT": "Log out"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "zile de încercare rămase.",
    "TRAIL_BUTTON": "Cumpara acum",
    "DELETED_USER": "Utilizator șters",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Cont suspendat",
      "MESSAGE": "Contul tău este suspendat. Vă rugăm să contactați echipa de asistență pentru mai multe informații."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Log out"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiază",
      "CODEPEN": "Deschis în CodePen",
      "COPY_SUCCESSFUL": "Cod copiat în clipboard cu succes"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Arată mai multe",
      "SHOW_LESS": "Afișați mai puține"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descărcare",
      "UPLOADING": "Încărcare...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Această poveste nu mai este disponibilă.",
      "INSTAGRAM_STORY_REPLY": "A răspuns la povestea ta:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Vezi pe hartă"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Trimite"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verificare...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Adaugă Inbox"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "În prezent, vizualizarea:",
    "SWITCH": "Comută contul",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Conversații",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Toate conversațiile",
    "MENTIONED_CONVERSATIONS": "Menţionări",
    "PARTICIPATING_CONVERSATIONS": "Participante",
    "UNATTENDED_CONVERSATIONS": "Neasistat",
    "REPORTS": "Rapoarte",
    "SETTINGS": "Setări",
    "CONTACTS": "Contacte",
    "ACTIVE": "Activ",
    "COMPANIES": "Companies",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_OVERVIEW": "Prezentare generală",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Căsuțe",
    "CAPTAIN_SETTINGS": "Setări",
    "HOME": "Acasa",
    "AGENTS": "Agenți",
    "AGENT_BOTS": "Boți",
    "AUDIT_LOGS": "Jurnale de audit",
    "INBOXES": "Căsuțe",
    "NOTIFICATIONS": "Notificări",
    "CANNED_RESPONSES": "Răspunsuri predefinite",
    "INTEGRATIONS": "Integrări",
    "DATA": "Data",
    "PROFILE_SETTINGS": "Setări profil",
    "ACCOUNT_SETTINGS": "Setările contului",
    "APPLICATIONS": "Aplicatii",
    "LABELS": "Etichete",
    "CUSTOM_ATTRIBUTES": "Editează atribut personalizat",
    "AUTOMATION": "Automatizare",
    "MACROS": "Macrocomenzi",
    "TEAMS": "Echipe",
    "BILLING": "Facturare",
    "CUSTOM_VIEWS_FOLDER": "Foldere",
    "CUSTOM_VIEWS_SEGMENTS": "Segmente",
    "ALL_CONTACTS": "Toate persoanele de contact",
    "TAGGED_WITH": "Etichetate cu",
    "NEW_LABEL": "Etichetă nouă",
    "NEW_TEAM": "Echipă nouă",
    "NEW_INBOX": "Inbox nou",
    "REPORTS_CONVERSATION": "Conversații",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Campanii",
    "ONGOING": "În derulare",
    "ONE_OFF": "Unul oprit",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenți",
    "REPORTS_LABEL": "Etichete",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Echipa",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "Setați-vă ca",
    "SET_YOUR_AVAILABILITY": "Setați-vă disponibilitatea",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Prezentare generală",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Asistenta",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categorii",
      "LOCALES": "Limbi",
      "SETTINGS": "Setări"
    },
    "CHANNELS": "Canale",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcarea automată a offline-ului",
      "INFO_TEXT": "Permiteți sistemului să vă marcheze automat offline atunci când nu utilizați aplicația sau tabloul de bord.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "SORT_TOOLTIP": "Sort",
    "SORT_BY": "Sortați după",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Citiți Documente",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Importă",
      "EXPORT": "Exportă"
    },
    "TYPES": {
      "CONTACTS": "Contacte",
      "CONVERSATIONS": "Conversații",
      "MESSAGES": "Mesaje"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "Renunță",
      "IMPORT": "Importă"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Importă",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "Nume",
      "TYPE": "Tip",
      "STATUS": "Status",
      "IMPORTED": "Imported",
      "CREATED": "Creat",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Creat",
      "DURATION": "Durata",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "Toate",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "Mesaj"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "Reîmprospătare",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "Finalizată",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Caracteristici",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturare",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Pentru acest plan nu sunt disponibile extraoptiuni",
      "PLAN_NOTE": "În prezent sunteți abonat la planul **{plan}** cu licențe **{quantity}**",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gestionați-vă abonamentul",
      "DESCRIPTION": "Vizualizați facturile anterioare, editați detaliile de facturare sau anulați abonamentul.",
      "BUTTON_TXT": "Accesați portalul de facturare"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more.",
      "REFRESH_CREDITS": "Reîmprospătare"
    },
    "CHAT_WITH_US": {
      "TITLE": "Aveţi nevoie de ajutor?",
      "DESCRIPTION": "Vă confruntați cu probleme în facturare? Suntem aici pentru a vă ajuta.",
      "BUTTON_TXT": "Discută cu noi"
    },
    "NO_BILLING_USER": "Contul de facturare este configurat. Vă rugăm să reîmprospătați pagina și încercați din nou.",
    "TOPUP": {
      "BUY_CREDITS": "Buy more credits",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Observație:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Renunță",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Înapoi",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "Cod copiat în clipboard cu succes",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Cauta atribute"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Rezolvarea conversației",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Rezolvarea conversației",
          "CANCEL": "Renunță"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Select an option"
        },
        "CHECKBOX": {
          "YES": "Da",
          "NO": "Nu"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! Nu am putut găsi niciun cont Chatwoot. Vă rugăm să creați un cont nou pentru a continua.",
    "NEW_ACCOUNT": "Cont Nou",
    "SELECTOR_SUBTITLE": "Creează un cont nou",
    "API": {
      "SUCCESS_MESSAGE": "Agent actualizat cu succes",
      "EXIST_MESSAGE": "Contul există deja",
      "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nume companie",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Trimite",
      "CANCEL": "Renunță"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Vizualizați toate comenzile rapide",
    "TITLE": {
      "OPEN_CONVERSATION": "Deschiderea conversației",
      "RESOLVE_AND_NEXT": "Rezolvarea și trecerea la următorul",
      "NAVIGATE_DROPDOWN": "Navigarea elementelor verticale",
      "RESOLVE_CONVERSATION": "Detalii conversație",
      "GO_TO_CONVERSATION_DASHBOARD": "Accesați Tabloul de bord conversație",
      "ADD_ATTACHMENT": "Fişier ataşat",
      "GO_TO_CONTACTS_DASHBOARD": "Accesați Tabloul de bord persoane de contact",
      "TOGGLE_SIDEBAR": "Comutare bară laterală",
      "GO_TO_REPORTS_SIDEBAR": "Accesați bara laterală Rapoarte",
      "MOVE_TO_NEXT_TAB": "Deplasarea la fila următoare din lista de conversații",
      "GO_TO_SETTINGS": "Accesați Pagina Setări",
      "SWITCH_TO_PRIVATE_NOTE": "Comutarea la Notă privată",
      "SWITCH_TO_REPLY": "Comutarea la Răspuns",
      "TOGGLE_SNOOZE_DROPDOWN": "Comutați snooze dropdown"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "Prioritate",
          "ACTIVE": "Activ",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "Editare"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Renunță"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Descriere:",
          "PLACEHOLDER": "Enter description"
        },
        "STATUS": {
          "LABEL": "Status:",
          "PLACEHOLDER": "Select status",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "Adaugă"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "Editare"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Renunță"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Descriere:",
          "PLACEHOLDER": "Enter description"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "Adaugă"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "Şterge",
      "CANCEL_BUTTON_LABEL": "Renunță"
    }
  }
}
